import { KTBSDropdownDirections } from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import useOnClickOutside from 'hooks/useOnClickOutside';
import useWindowSize from 'hooks/useWindowSize';
import PropTypes from 'prop-types';
import { cloneElement, useEffect, useRef, useState } from 'react';

ButtonFilterDropdown.propTypes = {
  dropdownContent: PropTypes.element,
  filtering: PropTypes.bool,
  direction: PropTypes.oneOf(Object.values(KTBSDropdownDirections)),
  desktopContentWidth: PropTypes.number,
};

function ButtonFilterDropdown({
  dropdownContent = <></>,
  filtering = false,
  direction = KTBSDropdownDirections.down,
  desktopContentWidth = 460,
}) {
  // MARK: ---- PROPERTIES ----
  const ref = useRef();
  const [zIndex, setZIndex] = useState('');
  const [show, setShow] = useState(false);
  useEffect(() => {
    setZIndex(show ? '99' : '');
  }, [show]);
  useOnClickOutside(ref, () => {
    if (show) {
      setShow(false);
    }
  });
  const windowSize = useWindowSize();

  // MARK: ---- METHODS ----
  const closeDropdown = () => {
    setShow(false);
  };

  return (
    <div
      ref={ref}
      className="position-relative"
      style={{
        zIndex: zIndex,
      }}
    >
      {UIHelper.buildNegativeButton(
        'Bộ lọc',
        () => {
          setShow(!show);
        },
        <div className="position-relative">
          <i className="fa-solid fa-filter" style={{ color: AppColors.gray[800] }} />
          {filtering && (
            <i
              className="position-absolute fa-solid fa-circle"
              style={{
                color: 'orange',
                top: '-2px',
                right: '-4px',
                fontSize: '7px',
              }}
            />
          )}
        </div>
      )}
      {show && (
        <div
          className="position-absolute bg-white shadow-sm filter-dropdown-content"
          style={{
            borderRadius: '5px',
            width:
              windowSize.width <= 768 ? 'calc(100vw - 52px)' : `${desktopContentWidth}px`,
            left: windowSize.width <= 768 ? '0' : '',
            right: windowSize.width > 768 ? '0' : '',
            zIndex: '9999',
            top: direction === "dropdown" ? "100%" : "auto",
            bottom: direction === "dropup" ? "100%" : "auto",
          }}
        >
          {cloneElement(dropdownContent, { closeDropdown })}
        </div>
      )}
    </div>
  );
}

export default ButtonFilterDropdown;
